"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShortUrl = exports.Tasks = void 0;
const server_sdk_1 = require("@air/server-sdk");
const types_1 = require("@air/types");
const querystring_1 = require("querystring");
const clips_1 = require("./clips");
const items_1 = require("./items");
const request_1 = require("./request");
const util_1 = require("./util");
const formatPermissions = (obj) => {
    if (!obj) {
        return {};
    }
    const { canContribute, canContributeAnon, canDiscuss, canDownloadClips, canEditCustomFields, canEditFormAssets, canViewAssetVersions, canViewClips, asset, customField, } = obj;
    const permissions = asset || customField
        ? { asset: asset || {}, customField: customField || {} }
        : undefined;
    return {
        canContribute,
        canContributeAnon,
        canDiscuss,
        canDownloadClips,
        canEditCustomFields,
        canEditFormAssets,
        canViewAssetVersions,
        canViewClips,
        permissions,
    };
};
/**
 *
 * __DEPRECATE__
 *
 * Returns the short ID to share. Will automatically generate a short ID if one
 * does not already exist for the object.
 * @deprecated - use type specific endpoints
 * @param args
 * @param args.workspaceId the workspace ID
 * @param args.id the object's ID
 * @param args.type the object's type. Currently can be 'clip' or 'board'
 * @param args.updateObj optional additional fields to update
 */
function getShortIdForObject(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, id, type, updateObj, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: 'share',
            workspaceId,
            method: 'POST',
            body: Object.assign({ objectId: id, objectType: type }, updateObj),
            boardContext: type === types_1.ShortUrlObjectType.board ? id : undefined,
        });
    });
}
/**
 * Creates shareId for clip
 * @param input.id Clip id to share
 * @param input.permissions Permissions to set for share object
 * @param input.passcode Passcode for share object
 * @param input.disabled disabled flag for share object
 * @param input.expirationDate expiration date for share object
 * @param input.boardContext Parent boardId of clip
 */
function getShortIdForClip(input) {
    return __awaiter(this, void 0, void 0, function* () {
        const { workspaceId, id, boardContext, permissions } = input, options = __rest(input, ["workspaceId", "id", "boardContext", "permissions"]);
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: 'share',
            workspaceId,
            method: 'POST',
            body: Object.assign(Object.assign({ objectId: id, objectType: types_1.ShortUrlObjectType.clip, boardContext }, formatPermissions(permissions)), options),
            boardContext,
        });
    });
}
/**
 * Creates shareId for board
 * @param input.id Board id to share
 * @param input.permissions Permissions to set for share object
 * @param input.passcode Passcode for share object
 * @param input.disabled disabled flag for share object
 * @param input.expirationDate expiration date for share object
 */
function getShortIdForBoard(input) {
    return __awaiter(this, void 0, void 0, function* () {
        const { workspaceId, id, permissions } = input, options = __rest(input, ["workspaceId", "id", "permissions"]);
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: 'share',
            workspaceId,
            method: 'POST',
            body: Object.assign(Object.assign({ objectId: id, objectType: types_1.ShortUrlObjectType.board }, formatPermissions(permissions)), options),
            boardContext: id,
        });
    });
}
/**
 * Creates shareId for form
 * @param input.id Form id to share
 * @param input.passcode Passcode for share object
 * @param input.disabled disabled flag for share object
 * @param input.expirationDate expiration date for share object
 */
function getShortIdForForm(input) {
    return __awaiter(this, void 0, void 0, function* () {
        const { workspaceId, id, boardContext } = input, options = __rest(input, ["workspaceId", "id", "boardContext"]);
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: 'share',
            workspaceId,
            method: 'POST',
            body: Object.assign({ objectId: id, objectType: types_1.ShortUrlObjectType.form, canContributeAnon: true }, options),
            boardContext,
        });
    });
}
/**
 * Returns a short ID for an object if a short ID has previously been created.
 * Does not automatically generate a short ID for an object that does not have one.
 *
 * @param args
 * @param args.workspaceId the workspace ID
 * @param args.id the object's ID
 * @param args.type the object's type. Currently can be 'clip' or 'board'
 * @param args.boardContext optional board ID associated with the short ID
 */
function getExistingShortIdForObject(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, id, type, boardContext, }) {
        // shares same REST endpoint as getShortIdForObject
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `share?${(0, querystring_1.stringify)({
                objectId: id,
                objectType: type,
                boardContext,
            })}`,
            workspaceId,
            method: 'GET',
            boardContext: type === types_1.ShortUrlObjectType.board ? id : undefined,
        });
    });
}
/**
 *
 * __DEPRECATE__
 * Replaces the existing short ID, effectively expiring it
 * @deprecated - use type specific methods
 * @param args
 * @param args.workspaceId the workspace ID
 * @param args.id Short ID to replace
 * @param args.update optional additional fields to update
 * @returns The new ID
 */
function regenerateShortId(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, id, update, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `regenerate`,
            workspaceId,
            method: 'POST',
            body: {
                id,
                update,
            },
        });
    });
}
/**
 * Regenerates a shortId for a board
 * @param input.id board id
 * @param input.permissions Permissions to set for share object
 * @param input.passcode Passcode for share object
 * @param input.boardContext BoardId associated with shortId
 */
function regenerateShortIdForBoard(input) {
    return __awaiter(this, void 0, void 0, function* () {
        const { workspaceId, shortId, boardContext, permissions } = input, options = __rest(input, ["workspaceId", "shortId", "boardContext", "permissions"]);
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `regenerate`,
            workspaceId,
            method: 'POST',
            body: {
                id: shortId,
                update: Object.assign(Object.assign({}, formatPermissions(permissions)), options),
            },
            boardContext,
        });
    });
}
/**
 * Regenerates a shortId for a clip
 * @param input.shortId clip shortId
 * @param input.permissions Permissions to set for share object
 * @param input.passcode Passcode for share object
 * @param input.boardContext BoardId associated with shortId
 */
function regenerateShortIdForClip(input) {
    return __awaiter(this, void 0, void 0, function* () {
        const { workspaceId, shortId, boardContext, permissions } = input, options = __rest(input, ["workspaceId", "shortId", "boardContext", "permissions"]);
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `regenerate`,
            workspaceId,
            method: 'POST',
            body: {
                id: shortId,
                update: Object.assign(Object.assign({}, formatPermissions(permissions)), options),
            },
            boardContext,
        });
    });
}
/**
 * Regenerates a shortId for a form
 * @param input.shortId form shortId
 * @param input.passcode Passcode for share object
 * @param input.boardContext BoardId associated with shortId
 */
function regenerateShortIdForForm(input) {
    return __awaiter(this, void 0, void 0, function* () {
        const { workspaceId, shortId, boardContext } = input, options = __rest(input, ["workspaceId", "shortId", "boardContext"]);
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `regenerate`,
            workspaceId,
            method: 'POST',
            body: {
                id: shortId,
                update: Object.assign({}, options),
            },
            boardContext,
        });
    });
}
/**
 * Update shortId permissions and/or passcode.
 * @param input.shortId ShortId to update
 * @param input.permissions New permissions to update
 * @param input.passcode New passcode to update
 * @param input.disabled disabled flag for share object
 * @param input.expirationDate expiration date for share object
 * @param input.boardContext Board context
 * @returns ShortUrlResponse
 */
function update(input) {
    return __awaiter(this, void 0, void 0, function* () {
        const { workspaceId, shortId, boardContext, permissions } = input, options = __rest(input, ["workspaceId", "shortId", "boardContext", "permissions"]);
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: 'update',
            workspaceId,
            method: 'POST',
            body: {
                id: shortId,
                update: Object.assign(Object.assign({}, formatPermissions(permissions)), options),
            },
            boardContext,
        });
    });
}
/**
 * Deletes the existing short ID
 * @param input.shortId ShortId to update
 * @param input.boardContext Board context
 * @returns nothing
 */
function deleteByShortId(input) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: input.shortId,
            workspaceId: input.workspaceId,
            method: 'DELETE',
            boardContext: input.boardContext,
        });
    });
}
/**
 * Returns the type of object and the associated data
 * @param id the short ID to look up
 */
function getByShortId(id) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: id,
            authorized: false,
            shortUrlProtection: { id },
        });
    });
}
/** Record a "unique" viewing of a shortUrl */
function view(_a) {
    return __awaiter(this, arguments, void 0, function* ({ shortId }) {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${shortId}/view`,
            method: 'POST',
            authorized: 'optional',
            shortUrlProtection: { id: shortId },
        });
    });
}
/**
 * Gets a shorturl's (board) statistics including total asset/file/subboard count and physical size
 * @param id the short ID to look up
 * @param boardId the ID of the board contained in the share object to get stats for
 * @param options
 *   includeDescendants - include all children in totals
 *   onlyCoverVersions - only get total size of current cover asset versions (clips)
 */
function getStatsByShortId(id, boardId, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const { includeDescendants = false, onlyCoverVersions = false } = options || {};
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${id}/stats?${(0, querystring_1.stringify)({
                boardId,
                includeDescendants,
                onlyCoverVersions,
            })}`,
            authorized: false,
            shortUrlProtection: { id },
        });
    });
}
/**
 * No more room in shortUrl service so these go to items service
 * @param id the shortUrl id
 * @param options clip and board list options
 */
function searchClipsAndBoardsByShortId(id, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const withDefaults = Object.assign(Object.assign({}, items_1.Items.defaultListOptions), options);
        return (0, request_1.airRequest)(types_1.EndpointType.items, {
            endpoint: `shortUrl/${id}/searchClipsAndBoardsByShortId`,
            method: 'POST',
            body: withDefaults,
            authorized: 'optional',
            shortUrlProtection: { id },
        });
    });
}
/**
 * Search clips and boards and return a grouped search result
 * @param id the shorturl id
 * @param options search options
 * @returns a grouped search response
 */
function searchClipsAndBoardsWithGroupingByShortId(id, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const withDefaults = Object.assign(Object.assign({}, items_1.Items.defaultListOptions), options);
        return (0, request_1.airRequest)(types_1.EndpointType.items, {
            endpoint: `shortUrl/${id}/searchClipsAndBoardsWithGroupingByShortId`,
            method: 'POST',
            body: withDefaults,
            authorized: 'optional',
            shortUrlProtection: { id },
        });
    });
}
function searchClipsByShortId(id_1, descendantBoardId_1) {
    return __awaiter(this, arguments, void 0, function* (id, descendantBoardId, options = {}) {
        const withDefaults = Object.assign(Object.assign(Object.assign({}, clips_1.Clips.CLIP_LIST_DEFAULTS), options), { descendantBoardId });
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${id}/clips/search`,
            method: 'POST',
            body: withDefaults,
            authorized: false,
            shortUrlProtection: { id },
        });
    });
}
function searchFilesByShortId(id_1, descendantBoardId_1) {
    return __awaiter(this, arguments, void 0, function* (id, descendantBoardId, options = {}) {
        return searchClipsByShortId(id, descendantBoardId, Object.assign(Object.assign({}, options), { types: types_1.ClipType.nonMedia }));
    });
}
function listViewFields(id, viewType) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${id}/viewFields?${(0, util_1.formatParamsForHttp)({
                viewType,
            })}`,
            authorized: false,
            shortUrlProtection: { id },
        });
    });
}
/**
 * @param options.includeAncestors only returns ancestors up to the shortId
 */
function listChildrenBoardsByShortId(shortId, parentId, options) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            method: 'POST',
            endpoint: `${shortId}/boards/${parentId}`,
            body: options,
            authorized: false,
            shortUrlProtection: { id: shortId },
        });
    });
}
function getBoardClip(shortId, clipId, options) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${shortId}/getBoardClip/${clipId}?${(0, querystring_1.stringify)(Object.assign({}, options))}`,
            authorized: false,
            shortUrlProtection: { id: shortId },
        });
    });
}
function getClip(_a) {
    return __awaiter(this, arguments, void 0, function* ({ shortId, clipId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${shortId}/clips/${clipId}`,
            authorized: false,
            shortUrlProtection: { id: shortId },
        });
    });
}
/**
 * Lists non-sensitive IPTC/Exif metadata fields on a clip
 * @param args
 * @param args.shortId short url id of the board or asset containing the clip
 * @param args.clipId the id of the clip to list metadata from
 * @param [args.cursor] the cursor to use for pagination
 * @param [args.limit] the number of metadata fields to return per page
 */
function listClipMetadata(_a) {
    return __awaiter(this, arguments, void 0, function* ({ shortId, clipId, cursor, limit, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${shortId}/clips/${clipId}/metadata?${(0, util_1.stringifyOptions)({
                cursor,
                limit,
            })}`,
            method: 'GET',
            authorized: false,
            shortUrlProtection: { id: shortId },
        });
    });
}
/**
 * List captured text for a clip
 * @param args
 * @param args.shortId short url id of the board or asset containing the clip
 * @param args.clipId the id of the clip to list captured text from
 * @param args.cursor the cursor to use for pagination
 * @param args.limit the number of captured text to return per page
 */
function listClipCapturedText(_a) {
    return __awaiter(this, arguments, void 0, function* ({ shortId, clipId, cursor, limit, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${shortId}/clips/${clipId}/capturedText?${(0, util_1.stringifyOptions)({
                cursor,
                limit,
            })}`,
            method: 'GET',
            authorized: false,
            shortUrlProtection: { id: shortId },
        });
    });
}
/**
 * Returns a board if board id is under the board shared with shortId, otherwise
 * throws an error
 * @param shortId Short id of the root board the requested board is under
 * @param boardId Board id of requested board
 */
function getDescendantBoard(shortId, boardId) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${shortId}/board/${boardId}`,
            authorized: false,
            shortUrlProtection: { id: shortId },
        });
    });
}
function getFilterLookupsForShortId(id, descendantBoardId) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${id}/lookups`,
            authorized: false,
            method: 'POST',
            body: { descendantBoardId },
            shortUrlProtection: { id },
        });
    });
}
/**
 * Get board context-sensitive data for search filtering
 *
 * @param args
 * @param args.shortId - short url id of the board to provide context for getting search filters
 * @param args.field - field to get filter lookups for
 * @param [args.descendantBoardId] - a contextual descendant board of the short url in which to get filters
 * @param [args.search] - search term to filter lookups by
 * @param [args.limit] - limit the number of lookups returned (default: 50, max: 100)
 * @param [rest.camera] - camera context to filter lookups by
 * @param [rest.location] - location context to filter lookups by
 */
function getAssetVersionFilterLookups(_a) {
    return __awaiter(this, void 0, void 0, function* () {
        var { shortId, field, descendantBoardId } = _a, rest = __rest(_a, ["shortId", "field", "descendantBoardId"]);
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${shortId}/lookups/versions/${field}`,
            method: 'POST',
            body: Object.assign({ boardId: descendantBoardId }, rest),
            authorized: false,
            shortUrlProtection: { id: shortId },
        });
    });
}
function getEntityLookupsForShortId(id, options) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${id}/entityLookups`,
            authorized: false,
            method: 'POST',
            body: options,
            shortUrlProtection: { id },
        });
    });
}
function getSuggestions(id, searchTerm, limit) {
    return __awaiter(this, void 0, void 0, function* () {
        const paramString = (0, querystring_1.stringify)({ search: searchTerm, limit });
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${id}/suggestions?${paramString}`,
            authorized: false,
            shortUrlProtection: { id },
        });
    });
}
function getDownloadUrl(shortId, clipId) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${shortId}/download/${clipId}`,
            authorized: 'optional',
            shortUrlProtection: { id: shortId },
        });
    });
}
function checkCanUpload(shortId, size) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${shortId}/canUpload`,
            method: 'POST',
            body: { size },
            authorized: 'optional',
            shortUrlProtection: { id: shortId },
        });
    });
}
/**
 * Returns a board if board id is under the board shared with shortId, otherwise throws an error
 * @param shortId Short id of the board to upload to
 * @param files File upload data
 * @param uploadParams Includes clip source and optional descendantBoardId
 *                     which is currently not used by this endpoint
 */
function getUploadUrls(shortId, files, uploadParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${shortId}/batch/upload`,
            method: 'POST',
            authorized: 'optional',
            body: Object.assign({ files }, uploadParams),
            shortUrlProtection: { id: shortId },
        });
    });
}
/**
 * Adds clips to db, creates multipart uploads for each file,
 * and returns a list of UploadIds that can be used to retrieve
 * urls to upload file chunks, as well as the file Key generated from
 * clipId and ext
 * @param shortId Short id of the board to upload to
 * @param files List of file data
 * @param uploadParams ClipSource
 */
function createMultipartUploads(shortId, files, uploadParams) {
    return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
        endpoint: `${shortId}/batch/upload/multipart`,
        method: 'POST',
        authorized: 'optional',
        body: Object.assign({ files }, uploadParams),
        shortUrlProtection: { id: shortId },
    });
}
/**
 * Gets a url for a chunk of a multipart upload
 * @param shortId Short id of the board to upload to
 * @param Key Object key generated from clipId and ext and returned from multipart upload creation
 * @param UploadId UploadId returned from S3 after creating multipart upload
 * @param PartNumber Index of chunk to upload
 */
function getPartUploadUrl(shortId, Key, UploadId, PartNumber) {
    return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
        endpoint: `${shortId}/multipart`,
        method: 'POST',
        authorized: 'optional',
        body: {
            Key,
            UploadId,
            PartNumber,
        },
        shortUrlProtection: { id: shortId },
    });
}
/**
 * Merges the file upload parts and moves it from multipart bucket into pipeline bucket
 * @param shortId Short id of the board being upload to
 * @param Key Object key generated from clipId and ext and returned from multipart upload creation
 * @param UploadId UploadId returned from S3 after creating multipart upload
 * @param Parts An array of chunk indexes assigned by client and chunk identifiers returned from S3
 */
function completeMultipartUpload(shortId, Key, UploadId, Parts) {
    return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
        endpoint: `${shortId}/multipart/complete`,
        method: 'POST',
        authorized: 'optional',
        body: {
            Key,
            UploadId,
            Parts,
        },
        shortUrlProtection: { id: shortId },
    });
}
/**
 * Aborts a multipart upload and removes its corresponding parts
 * @param shortId Short id of the board being uploaded to
 * @param Key Object key generated from clipId and ext and returned from multipart upload creation
 * @param UploadId UploadId returned from S3 after creating multipart upload
 */
function abortMultipartUpload(shortId, Key, UploadId) {
    return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
        endpoint: `${shortId}/multipart`,
        method: 'DELETE',
        authorized: 'optional',
        body: {
            Key,
            UploadId,
        },
        shortUrlProtection: { id: shortId },
    });
}
/**
 * Throws MISSING_OR_INVALID_SHORT_URL_PASSCODE if passcode is incorrect, otherwise
 * returns a ShortUrlToken object
 *
 * @param shortId Id of shorturl
 * @param passcode Required passcode input
 */
function verifyShortUrl(shortId, passcode) {
    return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
        endpoint: `${shortId}/verify`,
        method: 'POST',
        body: {
            passcode,
        },
        authorized: false,
    });
}
function getCustomField(shortId, customFieldId) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            method: 'GET',
            endpoint: `${shortId}/customFields/${customFieldId}`,
            authorized: false,
            shortUrlProtection: { id: shortId },
        });
    });
}
function listCustomFields(shortId_1) {
    return __awaiter(this, arguments, void 0, function* (shortId, options = {}) {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${shortId}/customfields?${(0, util_1.formatParamsForHttp)(options)}`,
            method: 'GET',
            authorized: false,
            shortUrlProtection: { id: shortId },
        });
    });
}
function listCustomFieldValues(shortId, customFieldId) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${shortId}/customfields/${customFieldId}/values`,
            method: 'GET',
            authorized: false,
            shortUrlProtection: { id: shortId },
        });
    });
}
function listAssetCustomFields(shortId_1, assetId_1) {
    return __awaiter(this, arguments, void 0, function* (shortId, assetId, options = {}) {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${shortId}/assets/${assetId}/customfields?${(0, util_1.formatParamsForHttp)(options)}`,
            method: 'GET',
            authorized: false,
            shortUrlProtection: { id: shortId },
        });
    });
}
function listBoardCustomFields(shortId_1, boardId_1) {
    return __awaiter(this, arguments, void 0, function* (shortId, boardId, options = {}) {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${shortId}/boards/${boardId}/customfields?${(0, util_1.formatParamsForHttp)(options)}`,
            method: 'GET',
            authorized: false,
            shortUrlProtection: { id: shortId },
        });
    });
}
/**
 * Sets asset-level custom field value for single-select custom field
 */
function setAssetCustomFieldValue(_a) {
    return __awaiter(this, arguments, void 0, function* ({ shortId, customFieldId, assetIds, valueId, plainTextValue, dateValue, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${shortId}/assets/customfields/${customFieldId}`,
            method: 'PUT',
            shortUrlProtection: { id: shortId },
            body: {
                assetIds,
                valueId,
                plainTextValue,
                dateValue,
            },
        });
    });
}
/**
 * Sets asset-level custom field values for multi-select custom field
 */
function setAssetCustomFieldValues(_a) {
    return __awaiter(this, arguments, void 0, function* ({ shortId, customFieldId, assetIds, valueIdsToAdd, valueIdsToRemove, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${shortId}/assets/customfields/${customFieldId}`,
            method: 'PUT',
            shortUrlProtection: { id: shortId },
            body: {
                assetIds,
                valueIdsToAdd,
                valueIdsToRemove,
            },
        });
    });
}
/**
 * Sets board-level custom field value for single-select custom field
 */
function setBoardCustomFieldValue(_a) {
    return __awaiter(this, arguments, void 0, function* ({ shortId, customFieldId, boardIds, valueId, plainTextValue, dateValue, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${shortId}/boards/customfields/${customFieldId}`,
            method: 'PUT',
            shortUrlProtection: { id: shortId },
            body: {
                boardIds,
                valueId,
                plainTextValue,
                dateValue,
            },
        });
    });
}
/**
 * Sets board-level custom field values for multi-select custom field
 */
function setBoardCustomFieldValues(_a) {
    return __awaiter(this, arguments, void 0, function* ({ shortId, customFieldId, boardIds, valueIdsToAdd, valueIdsToRemove, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${shortId}/boards/customfields/${customFieldId}`,
            method: 'PUT',
            shortUrlProtection: { id: shortId },
            body: {
                boardIds,
                valueIdsToAdd,
                valueIdsToRemove,
            },
        });
    });
}
/**
 * creates a session for the provided formId
 * @param shortId: the shortId tied to the form
 * @param formId the associated formId that a session is being created on
 * @returns an object with an id of the created session
 */
function createFormSession({ shortId, formId, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
        endpoint: `${shortId}/forms/${formId}/sessions`,
        method: 'POST',
        authorized: 'optional',
        shortUrlProtection: { id: shortId },
    });
}
function submitFormSession({ shortId, formId, sessionId, name, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
        endpoint: `${shortId}/forms/${formId}/sessions/${sessionId}/submit`,
        method: 'POST',
        authorized: 'optional',
        shortUrlProtection: { id: shortId },
        body: {
            name,
        },
    });
}
function deleteFormSessionAssets({ shortId, formId, sessionId, assetIds, }) {
    return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
        endpoint: `${shortId}/forms/${formId}/sessions/${sessionId}/assets`,
        method: 'DELETE',
        authorized: false,
        body: {
            assetIds,
        },
        shortUrlProtection: { id: shortId },
    });
}
function batchUpdateFormAssets(shortId, formId, input) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${shortId}/forms/${formId}/sessions/${input.formSessionId}/assets/batch`,
            method: 'POST',
            authorized: false,
            body: input,
            shortUrlProtection: { id: shortId },
        });
    });
}
/**
 * Lists the add-ons for the shorturl's workspace
 * @param shortId the shortId to list add-ons for
 */
function listAddOns(_a) {
    return __awaiter(this, arguments, void 0, function* ({ shortId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
            endpoint: `${shortId}/addons`,
            method: 'GET',
            authorized: false,
            shortUrlProtection: { id: shortId },
        });
    });
}
exports.Tasks = {
    getTask(shortId, args) {
        return (0, request_1.airRequest)(server_sdk_1.ShortUrl.Tasks.get, {
            body: args,
            authorized: 'optional',
            shortUrlProtection: { id: shortId },
        });
    },
    listTasks(shortId, args = {}) {
        return (0, request_1.airRequest)(server_sdk_1.ShortUrl.Tasks.list, {
            body: args,
            authorized: 'optional',
            shortUrlProtection: { id: shortId },
        });
    },
    createTask(shortId, args, boardContext) {
        return (0, request_1.airRequest)(server_sdk_1.ShortUrl.Tasks.create, {
            body: args,
            authorized: 'optional',
            shortUrlProtection: { id: shortId },
        });
    },
    ContentExporter: {
        getDownloadUrl(shortId, args) {
            return __awaiter(this, void 0, void 0, function* () {
                return (0, request_1.airRequest)(types_1.EndpointType.shorturl, {
                    endpoint: `${shortId}/tasks/ContentExporter/${args.taskId}/download`,
                    authorized: 'optional',
                    shortUrlProtection: { id: shortId },
                });
            });
        },
    },
};
exports.ShortUrl = {
    Tasks: exports.Tasks,
    getShortIdForObject,
    getShortIdForClip,
    getShortIdForBoard,
    getShortIdForForm,
    getExistingShortIdForObject,
    regenerateShortId,
    regenerateShortIdForBoard,
    regenerateShortIdForClip,
    regenerateShortIdForForm,
    update,
    deleteByShortId,
    getByShortId,
    view,
    getStatsByShortId,
    searchClipsAndBoardsByShortId,
    searchClipsAndBoardsWithGroupingByShortId,
    searchClipsByShortId,
    searchFilesByShortId,
    listViewFields,
    listChildrenBoardsByShortId,
    getBoardClip,
    getClip,
    listClipMetadata,
    listClipCapturedText,
    getDescendantBoard,
    getFilterLookupsForShortId,
    getAssetVersionFilterLookups,
    getEntityLookupsForShortId,
    getSuggestions,
    getDownloadUrl,
    getCustomField,
    listCustomFields,
    listCustomFieldValues,
    listAssetCustomFields,
    listBoardCustomFields,
    listAddOns,
    setAssetCustomFieldValue,
    setAssetCustomFieldValues,
    setBoardCustomFieldValue,
    setBoardCustomFieldValues,
    batchUpdateFormAssets,
    checkCanUpload,
    getUploadUrls,
    createMultipartUploads,
    getPartUploadUrl,
    completeMultipartUpload,
    abortMultipartUpload,
    verifyShortUrl,
    createFormSession,
    submitFormSession,
    deleteFormSessionAssets,
};
//# sourceMappingURL=shortUrl.js.map